import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-house-club-competition',
  templateUrl: './house-club-competition.component.html',
  styleUrls: ['./house-club-competition.component.scss']
})
export class HouseClubCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
